import { render } from "./CategoriesDetails.vue?vue&type=template&id=4e002c6c&scoped=true"
import script from "./CategoriesDetails.vue?vue&type=script&lang=js"
export * from "./CategoriesDetails.vue?vue&type=script&lang=js"

import "./CategoriesDetails.vue?vue&type=style&index=0&id=4e002c6c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e002c6c"]])

export default __exports__